export enum StateEnumType {
  FULFILLED = 'FULFILLED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  PROGRESS = 'PROGRESS'
}

export type StateType = 'FULFILLED' | 'REJECTED' | 'PENDING' | 'PROGRESS';

export const FULFILLED: StateType = 'FULFILLED';
export const REJECTED: StateType = 'REJECTED';
export const PENDING: StateType = 'PENDING';
export const PROGRESS: StateType = 'PROGRESS';

export type FULFILLED = typeof FULFILLED;
export type REJECTED = typeof REJECTED;
export type PENDING = typeof PENDING;
export type PROGRESS = typeof PROGRESS;
